function addEntry({
  items, url, dest, title,
}, entries = []) {
  entries.push({
    id: entries.length, url, dest, title,
  });
  items.forEach(childEntry => addEntry(childEntry, entries));
  return entries;
}

export function flattenOutline(outline) {
  if (outline.length === 0) return [];
  return addEntry(outline[0]);
}
